import { getUrl } from "utils";
import client from "utils/connected/api";

export const getQuotaLimitsRequest = (filterParams) => client.get(getUrl("quota-limits", filterParams));

export const createQuotaLimitRequest = (data) => client.post("quota-limits", data);

export const deleteQuotaLimitRequest = (id) => client.delete(`quota-limit/${id}`);

export const patchQuotaLimitRequest = ({ body, id }) => client.patch(`quota-limit/${id}`, body);
